export type UploadFileType = "csv" | "pdf" | "xlsx"

export const isCsvFile = (file: File): boolean =>
  file.name.toLowerCase().endsWith(".csv")

export const isPdfFile = (file: File): boolean =>
  file.name.toLowerCase().endsWith(".pdf") || file.type === "application/pdf"

const isXlsxFile = (file: File): boolean =>
  file.name.toLowerCase().endsWith(".xlsx")

export const isAcceptedUploadFile = (
  file: File,
  acceptedFileTypes: readonly UploadFileType[]
): boolean =>
  acceptedFileTypes.some((fileType) => {
    if (fileType === "csv") {
      return isCsvFile(file)
    }

    if (fileType === "pdf") {
      return isPdfFile(file)
    }

    if (fileType === "xlsx") {
      return isXlsxFile(file)
    }

    const _exhaustive: never = fileType
    return _exhaustive
  })

export const hasOnlyPdfFiles = (files: File[]): boolean =>
  files.length > 0 && files.every((file) => isPdfFile(file))

export const hasSingleSpreadsheetFile = (
  files: File[],
  excelEnabled: boolean
): boolean =>
  files.length === 1 &&
  (isCsvFile(files[0]) || (excelEnabled && isXlsxFile(files[0])))
